import { LogLevel, StsConfigHttpLoader } from 'angular-auth-oidc-client';
import { from, map } from 'rxjs';

/**
 * OIDC-Konfigurationsloader.
 *
 * Der HttpClient von Angular funktioniert hier nicht zuverlässig, weil provideAuth() sehr früh
 * im Bootstrap-Prozess ausgeführt wird (noch bevor Angulars Dependency Injection und Zone vollständig aktiv sind).
 *
 * Deshalb wird hier bewusst die Fetch-API verwendet, die unabhängig vom Angular-Lifecycle funktioniert.
 */
export const httpLoaderFactory = (): StsConfigHttpLoader => {
  const config$ = from(fetch(`${window.origin}/assets/app.config.json`).then(response => response.json())).pipe(
    map(config => ({
      authority: config.authorityUrl,
      redirectUrl: window.origin + '/org-login-in-progress',
      postLoginRoute: '/org-admin-client/v2',
      postLogoutRedirectUri: window.origin + '/login',
      configId: 'configIdIDP',
      clientId: 'org-admin-client',
      scope: 'openid profile email offline_access',
      responseType: 'code',
      useRefreshToken: true,
      silentRenew: true,
      renewTimeBeforeTokenExpiresInSeconds: 60,
      logLevel: LogLevel.Debug
    }))
  );
  return new StsConfigHttpLoader(config$);
};
